import React, { type ComponentProps } from 'react';

import Button from '@adsk/alloy-react-button';

import DropdownButtonControl from './Control';
import type { ButtonTemplateProps, RenderControlElement } from '../../types';

type DefaultControlProps = ButtonTemplateProps & {
  variant?: ComponentProps<typeof Button>['variant'];
};

export type DefaultControlRendererFn = (
  props: DefaultControlProps,
) => RenderControlElement;

const defaultControlRenderer = (
  props: DefaultControlProps,
): RenderControlElement => <DropdownButtonControl {...props} />;

export default defaultControlRenderer;
